import React from 'react'
import Style from './createConnector.module.css'
import SystemTile from './SystemTile'

export const partnerOf = (integration, shortName) =>
    (integration.source.shortName === shortName ? integration.target.shortName : integration.source.shortName)

const displayName = (integration) => (integration.name || '').replace(/^i95Dev\s*/i, '')

const ChoosePartnerStep = ({ system, partners, isLoading, isError, onRetry, partnerShortName, onSelectPartner, matches, integrationId, onSelectIntegration }) => {
    if (isLoading) {
        return (
            <div className={Style.tiles} aria-busy="true">
                {Array.from({ length: 4 }).map((_, index) => <span key={index} className={Style.skeleton} />)}
            </div>
        )
    }
    if (isError) {
        return (
            <p className={Style.message} role="alert">
                The integrations for {system.name} could not be loaded. <button type="button" className={Style.textButton} onClick={onRetry}>Try again</button>
            </p>
        )
    }
    if (partners.length === 0) {
        return <p className={Style.message}>No integrations are available for {system.name} yet.</p>
    }

    return (
        <>
            <div className={Style.tiles}>
                {partners.map((partner) => (
                    <SystemTile
                        key={partner.shortName}
                        system={partner}
                        isSelected={partner.shortName === partnerShortName}
                        onSelect={() => onSelectPartner(partner.shortName)}
                    />
                ))}
            </div>
            {matches.length > 1 ? (
                <fieldset className={Style.choices}>
                    <legend className={Style.label}>Integration</legend>
                    {matches.map((integration) => (
                        <label key={integration.id} className={[Style.choice, String(integration.id) === String(integrationId) ? Style.choiceActive : ''].join(' ')}>
                            <input
                                type="radio"
                                name="integration"
                                value={integration.id}
                                checked={String(integration.id) === String(integrationId)}
                                onChange={() => onSelectIntegration(integration.id)}
                            />
                            <span>{displayName(integration)}</span>
                            <span className={Style.choiceMeta}>{integration.source.shortName} → {integration.target.shortName}</span>
                        </label>
                    ))}
                </fieldset>
            ) : null}
        </>
    )
}

export default ChoosePartnerStep
